var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolderArrow28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4v-9a4 4 0 0 0-4-4h-6.419A2.194 2.194 0 0 1 13.5 5.5 2.194 2.194 0 0 0 11.419 4H6Zm9.884 6.616 4 4a1.25 1.25 0 0 1 0 1.768l-4 4a1.25 1.25 0 0 1-1.768-1.768l1.866-1.866H8a1.25 1.25 0 1 1 0-2.5h7.982l-1.866-1.866a1.25 1.25 0 0 1 1.768-1.768Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderArrow28);
export default __webpack_public_path__ + "static/media/folder_arrow_28.4d029204.svg";
export { ForwardRef as ReactComponent };